module.exports = __webpack_public_path__ + "static/media/logos_desktop.f4c568d1.png";